// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2xnlY","buttons":"RemoveExpirationActionButtons_buttons__LjO2F"};